
<script lang="ts" setup>
import Button from "primevue/button";

defineOptions({
  inheritAttrs: false,
});

const emit = defineEmits(["click"]);

defineProps({
  noBorder: {
    type: Boolean,
    default: false,
  },
  outlined: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <Button
    :class="{ '!border-none': noBorder }"
    :outlined="outlined || noBorder"
    v-bind="$attrs"
    @click="emit('click', $event)"
  >
  <slot />
  </Button>
</template>
